import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo.jsx";
import "../style/userForms.css";
import { globalT } from "../utils/globalUtils.js";
import { forgotPassword } from "../service/auth.servide";

export const SendForgotForm = () => {
  const navigate = useNavigate();
  const [postErrors, setPostErrors] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");

  const [formData, setFormData] = useState({
    email: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    document.querySelector(".m-userform").classList.add("loading");
    setPostErrors(false);
    setConfirmationMessage("");

    try {
      const { data } = await forgotPassword({
        email: formData.email,
      });

      console.log(data);

      if (data.message) {
        document.querySelector(".m-userform").classList.remove("loading");
        setConfirmationMessage(globalT(data.message));
      }
    } catch (e) {
      const error = e.response.data.message;
      document.querySelector(".m-userform").classList.remove("loading");
      setPostErrors(globalT(error));
    }
  };

  return (
    <div className="m-userform">
      <Logo />
      <div className="m-title">{globalT("Establece tu nueva contraseña")}</div>
      <div className="m-subtitle">
        {globalT(
          "Introduce tu correo electrónico para restablecer tu contraseña."
        )}
      </div>
      {!confirmationMessage && (
        <form className="m-form main-form" onSubmit={handleSubmit}>
          <div className="m-input-group">
            <label>Email *</label>
            <input
              required
              type="email"
              name="email"
              placeholder={globalT("Escribe aquí tu email")}
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>
          {postErrors && <div className="m-error">{postErrors}</div>}
          <button className="m-button" type="submit">
            {globalT("Enviar")}
          </button>
        </form>
      )}
      {true && (
        <div className="m-confirmation pt-20">{confirmationMessage}</div>
      )}
    </div>
  );
};
